import { CommonModule, CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FuseAlertComponent } from '@fuse/components/alert';

import { TextBoxModule, MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DatePickerModule, DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AutoCompleteModule, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { TabModule } from '@syncfusion/ej2-angular-navigations';

import { TFMService } from 'app/mock-api/tfm.service';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {Observable, firstValueFrom, of} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';

import { FlightListComponent } from 'app/layout/common/list-flight/flight-list.component';
import { StayListComponent } from 'app/layout/common/list-stay/stay-list.component';
import { SearchComponent } from 'app/layout/common/search-widget/search.component';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { FuseCardComponent } from '@fuse/components/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TransferListComponent } from 'app/layout/common/list-transfer/transfer-list.component';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { CarListComponent } from 'app/layout/common/list-car/car-list.component';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { AiTravelService } from 'app/layout/common/ai-travel/ai-travel.service';

@Component({
  selector: 'popular-packages',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseAlertComponent,
    MatRadioModule,
    NgFor,
    NgClass,
    NgIf,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    CurrencyPipe,
    TextBoxModule,
    MaskedTextBoxModule,
    DatePickerModule,
    DateRangePickerModule,
    AutoCompleteModule,
    MultiSelectModule,
    SwitchModule,
    TabModule,
    TextFieldModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatStepperModule, 
    FlightListComponent,
    StayListComponent,
    SearchComponent, TransferListComponent, CarListComponent, FuseCardComponent, MatTooltipModule],
  templateUrl: './popular-packages.component.html',
  styleUrl: './popular-packages.component.scss',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularPackagesComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() readonly tripChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() readonly cartChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('stepperPackages') private _stepper: MatStepper;
  @ViewChild('carListRef') private carList: CarListComponent | null = null;

  fromControl = new FormControl('');
  
  filteredOptions: Observable<any[]>;

  public view: any = {
    statusses: [],
    cacheMode: false,
    destinations: [{name:'Zanzibar'}, {name:'Mauritius', selected:true}, {name:'Cape Town'}, {name:'Victoria Falls'}],
    quickBookLoading: false,
    quickBookBundle: null,
    searchError: null,
    flightSearchReady: false
  }

  /**
   * Constructor
   */
  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _tfmService: TFMService,
    private _tfmCartService: TFMCartService,
    private _quickChatService: QuickChatService,
    private _cd: ChangeDetectorRef,
    private toaster: ToastrService,
    private _route: ActivatedRoute,
    private _aiTravelService: AiTravelService
  ) {
    this.view.cacheMode = this._tfmService._cacheMode;

    this._tfmService.statusChange.subscribe(res => {
      console.log("statusChange", res);
      this.toaster.info(res.text, res.title || 'Search update', { timeOut: 2500 });

      if (res && res.isError) {
        this.view.searchError = res;
      }

      if (this.view.statusses.filter(x => x.id == res.id).length == 0) {
        this.view.statusses.forEach(s => {
          s.isComplete = true;
        });

        const newStatus = {
          ...res,
          isComplete: !res.isError,
          typedText: '',
          fullText: res.text || '',
          isTyping: false
        };

        this.view.statusses.push(newStatus);
        this.startTyping(newStatus, res.text || '', !!res.isError);
      }
      else {
        const existing = this.view.statusses.filter(x=>x.id == res.id)[0];
        existing.text = res.text;
        existing.title = res.title;
        existing.isComplete = !res.isError;
        existing.isError = res.isError;
        existing.fullText = res.text || '';
        this.startTyping(existing, res.text || '', !!res.isError);
      }

    this._cd.detectChanges();
  });
}

  private progressToastId?: number;
  private slowToastId?: number;
  private slowerToastId?: number;
  private hangToastId?: number;
  private slowTimers: any[] = [];
  private aiSearchPending = false;
  private typingTimers = new Map<string, any>();
  private typingSpeedMs = 24;
  private pendingStepperReset = false;

  /**
     * On init
     */
  ngOnInit(): void {
    const aiRequest = this._aiTravelService.consumePackageRequest();
    const hasAiRequest = !!aiRequest;
    if (aiRequest) {
      this.view.search = aiRequest.search;
      this.view.trip = aiRequest.trip;
      this.view.statusses = [];
      this.view.transfersReceived = 0;

      if (this.view.search) {
        this.view.search.method = 'dynamic';
      }

      if (this.view.trip) {
        this._tfmCartService.updateTrip(this.view.trip);
      }

      this.aiSearchPending = true;
    }

    if (this.view.cacheMode && !hasAiRequest) {  
      var search = this._tfmService.loadLocalStorage("search");
      if (search) {
        search.method = "dynamic";
        this.view.search = search;
        this._tfmService.log("popular", this.view.search);
      }

      var trip = this._tfmService.loadLocalStorage("trip");
      if (trip) {
        this.view.trip = trip;
      }
    }

    this._route.queryParams.subscribe(params => {
      const bundleId = params['bundleId'];
      if (bundleId) {
        this.startQuickBook(bundleId);
      }

      if (params['reset']) {
        if (this._stepper) {
          this._stepper.reset();
          this._cd.detectChanges();
        } else {
          this.pendingStepperReset = true;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.aiSearchPending) {
      this.searchClicked();
      this.aiSearchPending = false;
      this._cd.detectChanges();
    }

    if (this.pendingStepperReset) {
      this._stepper.reset();
      this.pendingStepperReset = false;
      this._cd.detectChanges();
    }
  }

  private async startQuickBook(bundleId: string): Promise<void> {
    if (this.view.quickBookLoading) {
      return;
    }

    this.view.quickBookLoading = true;
    this.view.quickBookBundle = null;

    try {
      const res = await this._tfmService.filterBundles(
        { id: bundleId, rateType: 'pps', isActive: true },
        false
      );
      const content = res?.content ?? [];
      const bundles = Array.isArray(content) ? content : Object.values(content);
      const bundle = bundles[0];

      if (!bundle) {
        this.toaster.error('Bundle not found for quick book.');
        this.view.quickBookLoading = false;
        return;
      }

      const payload = await this.buildQuickBookPayload(bundle);
      if (!payload) {
        this.view.quickBookLoading = false;
        return;
      }

      this.view.quickBookBundle = bundle;
      this.view.search = payload.search;
      this.view.trip = payload.trip;
      this.view.statusses = [];
      this.view.transfersReceived = 0;
      this.view.carsReceived = 0;

      this._tfmCartService.updateSearch(this.view.search);
      this._tfmCartService.updateTrip(this.view.trip);

      setTimeout(() => {
        if (this._stepper) {
          this.searchClicked();
        }
      }, 0);
    } catch (error) {
      console.error('Quick book failed:', error);
      this.toaster.error('Unable to rerun the bundle search.');
    } finally {
      this.view.quickBookLoading = false;
      this._cd.detectChanges();
    }
  }

  private async buildQuickBookPayload(bundle: any): Promise<{ search: any; trip: any } | null> {
    const departDate = this.parseDate(
      bundle.departDate ||
        bundle.search?.validFrom ||
        bundle.validFrom ||
        bundle.search?.departDate
    );
    const returnDate = this.parseDate(
      bundle.returnDate ||
        bundle.search?.validTo ||
        bundle.validTo ||
        bundle.search?.returnDate
    );

    if (!departDate) {
      this.toaster.error('Bundle is missing a departure date.');
      return null;
    }

    const finalReturnDate =
      returnDate || this.addDays(departDate, bundle.nights || 7);

    const originText =
      bundle.originName ||
      bundle.search?.fromText ||
      bundle.search?.from ||
      bundle.origin ||
      '';
    const destinationText =
      bundle.destinationName ||
      bundle.destination ||
      bundle.search?.toText ||
      bundle.search?.to ||
      '';

    if (!originText || !destinationText) {
      this.toaster.error('Bundle is missing origin or destination details.');
      return null;
    }

    const originPlace =
      bundle.search?.locationFrom?.place_id
        ? this.normalizePlace(bundle.search.locationFrom, originText)
        : this.normalizePlace(
            await this.resolvePlace(originText, 'airports'),
            originText
          );

    const destinationAirport =
      bundle.search?.locationTo?.place_id
        ? this.normalizePlace(bundle.search.locationTo, destinationText)
        : this.normalizePlace(
            await this.resolvePlace(destinationText, 'airports'),
            destinationText
          );

    const destinationCity = this.normalizePlace(
      await this.resolvePlace(destinationText, 'cities'),
      destinationText
    );

    if (!originPlace?.place_id || !destinationAirport?.place_id) {
      this.toaster.error('Unable to resolve bundle airports for quick book.');
      return null;
    }

    const hotelPlace = destinationCity?.place_id
      ? destinationCity
      : destinationAirport;

    const pax: any = {
      adult: bundle.adults ?? bundle.search?.pax?.adult ?? 2,
      teen: bundle.teens ?? bundle.search?.pax?.teen ?? 0,
      child: bundle.children ?? bundle.search?.pax?.child ?? 0,
      infant: bundle.infants ?? bundle.search?.pax?.infant ?? 0,
    };
    pax.total = pax.adult + pax.teen + pax.child + pax.infant;

    const occupancy =
      bundle.search?.occupancy && bundle.search.occupancy.length > 0
        ? bundle.search.occupancy
        : [
            {
              adultCount: pax.adult,
              teenCount: pax.teen,
              childCount: pax.child,
              infantCount: pax.infant,
              childAges: bundle.search?.childAges ?? '',
            },
          ];

    const search: any = {
      method: 'dynamic',
      dateFrom: departDate,
      dateTo: finalReturnDate,
      nights: bundle.nights || this.getNights(departDate, finalReturnDate),
      pax,
      occupancy,
      locationFrom: originPlace,
      locationTo: destinationAirport,
      fromText: originPlace.searchTerm || originPlace.name || originText,
      toText: destinationAirport.searchTerm || destinationAirport.name || destinationText,
      filters: bundle.search?.filters ?? {},
      flightSegments: bundle.search?.flightSegments ?? null,
    };

    const trip = {
      points: [
        {
          index: 0,
          title: originPlace.name || originText,
          date: departDate,
          nights: 0,
          type: 'airport',
          search: true,
          showInCart: true,
          place_id: originPlace.place_id,
          data: originPlace,
          options: { isReturn: true },
        },
        {
          index: 1,
          title: hotelPlace.name || destinationText,
          date: departDate,
          dateTo: finalReturnDate,
          nights: this.getNights(departDate, finalReturnDate),
          type: 'hotel',
          search: true,
          showInCart: true,
          place_id: hotelPlace.place_id,
          options: { isReturn: true },
        },
        {
          index: 2,
          title: destinationAirport.name || destinationText,
          date: finalReturnDate,
          nights: 0,
          type: 'airport',
          search: false,
          showInCart: true,
          place_id: destinationAirport.place_id,
          data: destinationAirport,
          options: { isReturn: true },
        },
      ],
    };

    return { search, trip };
  }

  private async resolvePlace(searchText: string, type: 'airports' | 'cities'): Promise<any | null> {
    if (!searchText) {
      return null;
    }
    try {
      const res: any = await firstValueFrom(
        this._tfmService.getPlaces(searchText, type)
      );
      return res?.content?.predictions?.[0] ?? null;
    } catch (error) {
      console.error('Failed to resolve place', searchText, type, error);
      return null;
    }
  }

  private normalizePlace(place: any, fallbackText: string): any {
    if (!place) {
      return { name: fallbackText, searchTerm: fallbackText };
    }

    const name =
      place.name ||
      place.description ||
      place.structured_formatting?.main_text ||
      fallbackText;
    const searchTerm =
      place.searchTerm ||
      place.structured_formatting?.main_text ||
      fallbackText;

    return {
      ...place,
      name,
      searchTerm,
    };
  }

  private parseDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  private addDays(date: Date, days: number): Date {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  }

  private getNights(start: Date, end: Date): number {
    const diff = end.getTime() - start.getTime();
    const nights = diff / (24 * 60 * 60 * 1000);
    return Math.max(1, Math.ceil(nights));
  }
  
  public searchClicked() {
    this.view.searchError = null;
    this.view.statusses = [];
    this.clearTypingTimers();

    this.resetToasts();
    this.progressToastId = this.toaster.info(
      'Searching flights, transfers and stays to build your package.',
      'Building packages',
      { disableTimeOut: true, tapToDismiss: false }
    ).toastId;

    this.slowTimers.push(setTimeout(() => {
      this.slowToastId = this.toaster.info(
        'Still working... fetching options from our suppliers.',
        'Please stay on the page',
        { timeOut: 5000 }
      ).toastId;
    }, 12000));

    this.slowTimers.push(setTimeout(() => {
      this.slowerToastId = this.toaster.warning(
        'Taking longer than usual. We\'re still searching — no need to refresh.',
        'Hang tight',
        { timeOut: 7000 }
      ).toastId;
    }, 25000));

    // Escalate if we still haven't finished after a while
    this.slowTimers.push(setTimeout(() => {
      this.hangToastId = this.toaster.error(
        'This search is taking too long. You can keep waiting, or adjust dates/destination and try again.',
        'Still searching...',
        { timeOut: 8000 }
      ).toastId;
    }, 45000));

    this.view.transfersReceived = 0;
    this.view.carsReceived = 0;
    if (this.view.search) {
      this.view.search.transfers = [];
      this.view.search.flights = undefined;
    }

    // Tear down hidden flight/transfer/car components so their ngOnInit fires fresh on next mount
    this.view.flightSearchReady = false;
    this._cd.detectChanges();

    this._stepper.next();

    // Re-mount on next tick — flight-list ngOnInit will start a fresh search with the current view.search
    setTimeout(() => {
      this.view.flightSearchReady = true;
      this._cd.detectChanges();
    }, 0);
  }

  public tripChanged(tripData) {

    this.view.trip = tripData;

    this._tfmCartService.updateTrip(this.view.trip);

    //this.getInterestingInfo();
  }
  public searchChanged(searchData) {
    this.view.search = searchData;

    if (this.view.search)
      this.view.search.method = "dynamic";
  }
  public goBackToSearch() {
    if (this._stepper) {
      this._stepper.selectedIndex = 0;
    }
  }
  public resultChanged(e, pointIndex = 0) {
    this._tfmService.log(e);

    if (e) {
      if (e.error) {
        this.view.searchError = e.error;
        this.resetToasts();
        this._cd.detectChanges();
        return;
      }
      if (e.trip && e.trip.points && e.trip.points[0].flights && e.trip.points[0].flights.length > 0) {
        this.view.search.flights = e.trip.points[0].flights.slice();
        this.computeCarDatesFromFlights();
        this._cd.detectChanges();
      } else if (e.data && e.data.flights && e.data.flights.length > 0) {
        this.view.search.flights = e.data.flights.slice();
        this.computeCarDatesFromFlights();
        this._cd.detectChanges();
      }

      if (e.data && e.data.transfers) {
        if (!this.view.search.transfers) {
          this.view.search.transfers = [];
        }

        e.data.transfers.forEach(t => {
          this.view.search.transfers.push(t);
        });
        this._tfmService.log("transfers", e.data.transfers, pointIndex);

        this.view.transfersReceived += 1;
        this._cd.detectChanges();
      }

      if (e.data && e.data.cars) {
        if (!this.view.search.cars) {
          this.view.search.cars = [];
        }

        e.data.cars.forEach(t => {
          t.point = pointIndex;
          this.view.search.cars.push(t);
        });
        this._tfmService.log("cars", e.data.cars, pointIndex);

        if (e.carPickupDate != null) {
          this.view.search.carPickupDate = e.carPickupDate;
        }
        if (e.carDropOffDate != null) {
          this.view.search.carDropOffDate = e.carDropOffDate;
        }

        // Ensure stay-list fuse-card can show cars: write to destination trip point (index 1)
        const carPointIndex = this.view.trip?.points?.length >= 2 ? 1 : pointIndex;
        if (this.view.trip?.points?.[carPointIndex]) {
          if (!this.view.trip.points[carPointIndex].cars) {
            this.view.trip.points[carPointIndex].cars = [];
          }
          this.view.trip.points[carPointIndex].cars = [...e.data.cars];
        }

        this.view.carsReceived += 1;
        this._cd.detectChanges();
      }
    }

    console.log("resultChanged", e, this.view);

    if (this.view.search && this.view.search.flights && this.view.search.transfers && this.view.transfersReceived >= 2) {
      this.completeToasts();
      this._cd.markForCheck();
      this._cd.detectChanges();
    }

    if (this._stepper)
      this._stepper.next();
  }

  /** When user replaces a flight in stay-list, refresh car rental pickup/drop-off times from the new flight times. */
  onFlightReplaced(): void {
    this.computeCarDatesFromFlights();
    this.carList?.refreshCarRentalDates?.();
    this._cd.markForCheck();
  }

  /**
   * Derive car rental pickup/drop-off from the current flight data and set on view.search.
   * Pickup = inbound flight arrival. Drop-off = return flight departure − 2h.
   * Called when flights first arrive and when the user replaces a flight, so the car search
   * payload (and therefore the add-item tokens used by the PDF) always has correct times.
   */
  private computeCarDatesFromFlights(): void {
    const flights = this.view.search?.flights;
    if (!Array.isArray(flights) || flights.length === 0) return;

    const selected = flights.find((f: any) => f.selected) ?? flights[0];
    const opts = selected?.originDestinationOptions;
    if (!opts?.length) return;

    const coerce = (v: any): Date | null => {
      if (!v) return null;
      const d = v instanceof Date ? new Date(v.getTime()) : new Date(v);
      return isNaN(d.getTime()) ? null : d;
    };

    const lastInboundSeg = opts[0]?.flightSegments?.length
      ? opts[0].flightSegments[opts[0].flightSegments.length - 1]
      : null;
    const inboundArrival = coerce(
      lastInboundSeg?.arriveTime ?? lastInboundSeg?.arrivalTime
        ?? opts[0]?.arriveTime ?? opts[0]?.arrivalTime
    );
    if (inboundArrival) {
      this.view.search.carPickupDate = inboundArrival;
    }

    if (opts.length >= 2) {
      const firstReturnSeg = opts[1]?.flightSegments?.length
        ? opts[1].flightSegments[0]
        : null;
      const returnDepart = coerce(
        firstReturnSeg?.departTime ?? firstReturnSeg?.departureTime
          ?? opts[1]?.departTime ?? opts[1]?.departureTime
      );
      if (returnDepart) {
        this.view.search.carDropOffDate = this._tfmService.addHours(new Date(returnDepart.getTime()), -2);
      }
    }

    // Separate one-way flights on the same trip point (e.g. Safair HLA->CPT + LIFT CPT->JNB)
    if (!this.view.search.carDropOffDate && flights.length > 1) {
      for (const f of flights) {
        if (f === selected) continue;
        const fOpts = f?.originDestinationOptions;
        if (!fOpts?.length) continue;
        const seg = fOpts[0]?.flightSegments?.length ? fOpts[0].flightSegments[0] : null;
        const dep = coerce(
          seg?.departTime ?? seg?.departureTime
            ?? fOpts[0]?.departTime ?? fOpts[0]?.departureTime
        );
        if (dep) {
          this.view.search.carDropOffDate = this._tfmService.addHours(new Date(dep.getTime()), -2);
          break;
        }
      }
    }

    // Also check trip points for separate return flights (non-roundtrip itineraries)
    if (!this.view.search.carDropOffDate) {
      const points = this.view.trip?.points;
      if (points?.length >= 2) {
        for (let i = points.length - 1; i >= 1; i--) {
          const pFlights = points[i]?.flights;
          if (!Array.isArray(pFlights) || pFlights.length === 0) continue;
          const rf = pFlights.find((f: any) => f.selected) ?? pFlights[0];
          const rOpts = rf?.originDestinationOptions;
          if (!rOpts?.length) continue;
          const segIdx = rOpts.length >= 2 ? 1 : 0;
          const seg = rOpts[segIdx]?.flightSegments?.length ? rOpts[segIdx].flightSegments[0] : null;
          const dep = coerce(seg?.departTime ?? seg?.departureTime ?? rOpts[segIdx]?.departTime ?? rOpts[segIdx]?.departureTime);
          if (dep) {
            this.view.search.carDropOffDate = this._tfmService.addHours(new Date(dep.getTime()), -2);
            break;
          }
        }
      }
    }
  }

  /**
   * Car rentals are only relevant for domestic (same-country) routes.
   * Returns true when both the origin and destination are in the same country.
   */
  public isDomesticSearch(): boolean {
    const from = this.view?.search?.locationFrom;
    const to = this.view?.search?.locationTo;

    const normalize = (loc: any): string => {
      if (!loc) return '';
      return (loc.country || loc.countryName || loc.countryCode || loc.countryAccessCode || '')
        .toString().trim().toLowerCase();
    };

    let fromCountry = normalize(from);
    let toCountry = normalize(to);

    // Fallback: when search locations have no country (e.g. Google Places without country), try trip points
    if ((!fromCountry || !toCountry) && this.view?.trip?.points?.length >= 2) {
      const pts = this.view.trip.points;
      const first = pts[0];
      const last = pts[pts.length - 1];
      if (!fromCountry) fromCountry = normalize(from?.place_id ? pts.find((p: any) => p.place_id === from.place_id) : first);
      if (!toCountry) toCountry = normalize(to?.place_id ? pts.find((p: any) => p.place_id === to.place_id) : last);
    }

    if (fromCountry && toCountry) {
      return fromCountry === toCountry;
    }

    // Fallback: known same-country airport pairs (e.g. South Africa: JNB–CPT)
    const textFrom = (from?.title || from?.name || from?.description || '').toLowerCase();
    const textTo = (to?.title || to?.name || to?.description || '').toLowerCase();
    const saMarkers = ['johannesburg', 'or tambo', 'jnb', 'cape town', 'cpt', 'durban', 'king shaka', 'dur', 'port elizabeth', 'plz', 'east london', 'george', 'grj'];
    const fromSA = saMarkers.some(m => textFrom.includes(m));
    const toSA = saMarkers.some(m => textTo.includes(m));
    if (fromSA && toSA) {
      return true;
    }

    return false;
  }

  toggleFilter(destination): void {
    this.view.destinations.forEach(x => x.selected = false);
    destination.selected = true;
  }

  getInterestingInfo() {
    console.log('view',this.view);
    var point = this.view.trip.points.filter(x=>x.type == 'hotel' && x.search)[0];


    if (point) {
      this._quickChatService.sendMessageToAI(`Give me 1 interesting fact about ${point.title}`, []).subscribe(res => {
        this._tfmService.log(res);
        if (res.choices && res.choices.length > 0) {
            var responseText = res.choices[0].message.content;

            this.view.interestingText = responseText;
        }
      });
    }
  }

  private startTyping(status: any, text: string, isError: boolean): void {
    const key = status?.id || status?.title || 'status';
    const existingTimer = this.typingTimers.get(key);

    if (existingTimer) {
      clearInterval(existingTimer);
      this.typingTimers.delete(key);
    }

    status.fullText = text || '';

    if (isError || !status.fullText) {
      status.typedText = status.fullText;
      status.isTyping = false;
      return;
    }

    status.typedText = '';
    status.isTyping = true;

    let index = 0;
    const timer = setInterval(() => {
      status.typedText += status.fullText.charAt(index);
      index += 1;

      if (index >= status.fullText.length) {
        clearInterval(timer);
        this.typingTimers.delete(key);
        status.isTyping = false;
      }

      this._cd.detectChanges();
    }, this.typingSpeedMs);

    this.typingTimers.set(key, timer);
  }

  private clearTypingTimers(): void {
    this.typingTimers.forEach((timer) => clearInterval(timer));
    this.typingTimers.clear();
  }

  private resetToasts(): void {
    this.clearTimers();
    if (this.progressToastId) {
      this.toaster.clear(this.progressToastId);
    }
    if (this.slowToastId) {
      this.toaster.clear(this.slowToastId);
    }
    if (this.slowerToastId) {
      this.toaster.clear(this.slowerToastId);
    }
    if (this.hangToastId) {
      this.toaster.clear(this.hangToastId);
    }
    this.progressToastId = this.slowToastId = this.slowerToastId = this.hangToastId = undefined;
  }

  private clearTimers(): void {
    this.slowTimers.forEach(t => clearTimeout(t));
    this.slowTimers = [];
  }

  private completeToasts(): void {
    this.clearTimers();
    if (this.progressToastId) {
      this.toaster.clear(this.progressToastId);
    }
    if (this.slowToastId) {
      this.toaster.clear(this.slowToastId);
    }
    if (this.slowerToastId) {
      this.toaster.clear(this.slowerToastId);
    }
    this.toaster.success('We found package options. Scroll down to pick your stay.', 'Search complete', { timeOut: 4000 });
  }

  ngOnDestroy(): void {
    this.clearTypingTimers();
    this.resetToasts();
  }
}
